import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { CarouselModule } from 'primeng/carousel';
import { TabViewModule } from 'primeng/tabview';
import { FormsModule } from '@angular/forms';
import { CalendarModule } from 'primeng/calendar';
import { DropdownModule } from 'primeng/dropdown';;
import { CardModule } from 'primeng/card';
import { SkeletonModule } from 'primeng/skeleton';
import { TerritoryCardComponent } from './territory-card.component';
import { TranslateModule } from '@ngx-translate/core';

@NgModule({
    declarations: [ TerritoryCardComponent],
    exports: [  TerritoryCardComponent],
    imports: [
        CommonModule,
        RouterModule,
        CarouselModule,
        TabViewModule,
        CardModule,
        FormsModule,
        CalendarModule,
        DropdownModule,
        SkeletonModule,
        TranslateModule
    ]
})
export class TerritoryModule { }